import React from 'react'
import { ICharacter } from '../../../../../../api/types/character'
import makeStyles from '@mui/styles/makeStyles'
import { Badge, Paper, Tab, Tabs, Theme } from '@mui/material'
import createStyles from '@mui/styles/createStyles'
import { ManaBar } from './components/ManaBar/ManaBar'
import { HpBar } from './components/HpBar/HpBar'
import { CharacterSheetHeader } from './components/CharacterSheetHeader/CharacterSheetHeader'
import { CharacterStats } from './components/CharacterStats/CharacterStats'
import { TabPanel } from '../../../../../../components/TabPanel/TabPanel'
import { CharacterActions } from './components/CharacterActions/CharacterActions'
import cx from 'classnames'
import { CharacterNotes } from '../CharacterNotes/CharacterNotes'
import { CharacterSkills } from './components/CharacterSkills/CharacterSkills'
import { CharacterInventory } from './components/CharacterInventory/CharacterInventory'
import { CharacterEffects } from './components/CharacterEffects/CharacterEffects'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    hidden: {
      display: 'none',
    },
    pm1: {
      padding: theme.spacing(0.5),
      marginRight: theme.spacing(0.5),
      marginLeft: theme.spacing(0.5),
      // marginBottom: theme.spacing(1),
    },
    card: {
      padding: theme.spacing(1),
      marginLeft: theme.spacing(1),
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
    },
  })
)

interface Props {
  char: ICharacter
  game_id?: number
  showChatTab?: () => void
  editable?: boolean
  onEditAttribute?: (name: string, newValue: string) => void
  onEditSkill?: (name: string, newValue: string) => void
  onEditWeaponProf?: (name: string, newValue: string) => void
}

export const CharacterSheet: React.FC<Props> = ({
  char,
  game_id,
  editable,
  showChatTab,
  onEditAttribute,
  onEditSkill,
  onEditWeaponProf,
}) => {
  const classes = useStyles()
  const [currentTab, setCurrentTab] = React.useState(0)

  const handleTabChange = (event: React.SyntheticEvent, newTab: number) => {
    setCurrentTab(newTab)
  }

  return (
    <>
      <Paper sx={{ marginBottom: '8px' }} className={classes.pm1}>
        <div className={classes.pm1}>
          <CharacterSheetHeader char={char} game_id={game_id} showChatTab={showChatTab} />
        </div>

        <div className={classes.pm1}>
          <div style={{ marginBottom: '4px' }}>
            <HpBar
              value={char.hp}
              valueMax={char.max_hp}
              editable={editable}
              onEdit={v => onEditAttribute && onEditAttribute('hp', v)}
            />
          </div>
          <ManaBar
            value={char.mana}
            valueMax={char.max_mana}
            editable={editable}
            onEdit={v => onEditAttribute && onEditAttribute('mana', v)}
          />
        </div>

        <Tabs
          value={currentTab}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab label="Cechy" />
          <Tab label="Umiejętności" />
          <Tab label="Ekwipunek" />
          <Tab className={cx(game_id || classes.hidden)} label="Akcje" />
          <Tab
            label={
              <Badge
                badgeContent={char.active_timed_effect_count}
                color="primary"
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right',
                }}
              >
                Efekty
              </Badge>
            }
          />
          <Tab label="Notatki" />
        </Tabs>
        <TabPanel value={currentTab} index={0}>
          <CharacterStats
            char={char}
            game_id={game_id}
            showChatTab={showChatTab}
            onEditAttribute={onEditAttribute}
            editable={editable}
          />
        </TabPanel>
        <TabPanel value={currentTab} index={1}>
          <CharacterSkills
            char={char}
            game_id={game_id}
            showChatTab={showChatTab}
            onEditSkill={onEditSkill}
            onEditWeaponProf={onEditWeaponProf}
            editable={editable}
          />
        </TabPanel>
        <TabPanel index={2} value={currentTab}>
          <CharacterInventory char_id={char.id} game_id={game_id} />
        </TabPanel>
        <TabPanel value={currentTab} index={3}>
          <div className={cx(game_id || classes.hidden)}>
            <CharacterActions character={char} game_id={game_id} />
          </div>
        </TabPanel>
        <TabPanel value={currentTab} index={4}>
          <CharacterEffects char_id={char.id} />
        </TabPanel>
        <TabPanel value={currentTab} index={5}>
          <CharacterNotes character={char} />
        </TabPanel>
      </Paper>
    </>
  )
}
